import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import FormSection from '../../../genie/components/form-section/FormSection';
import SortField from '../../../genie/components/sort-field/SortField';
import MessagesList from '../../../genie/components/messages-list/MessagesList';
import PredictedMessage from '../../../genie/components/predict-response/predicted-message/PredictedMessage';
import useLocalSort from '../../../hooks/useLocalSort';
import { COMMON_GENIE_SORT } from '../../../hooks/useGenieMessagesSort';
import PredictForm from './predict-form/PredictForm';

import scss from './PredictResponse.module.scss';

function PredictResponse({ onPredictResponse }) {
  const { t } = useTranslation('genie');

  const [isShowForm, setIsShowForm] = useState(true);
  const [sort, setSort] = useState(COMMON_GENIE_SORT);

  const predictedMessages = useSelector((state) => state.genieGo.predictedMessages);
  const isPredicting = useSelector((state) => state.genieGo.isPredicting);
  const isGeneratingAlternate = useSelector((state) => state.genieGo.isGeneratingAlternate);

  const sortedMessages = useLocalSort({ content: predictedMessages, sort: sort });

  const handleChangeForVisibility = () => {
    setIsShowForm((prevState) => !prevState);
  };

  const handleChangeSort = ({ sort, direction, getSortValue }) => {
    setSort({ sort, direction, getSortValue });
  };

  return (
    <div className={scss.sectionWrapper}>
      <FormSection isShowForm={isShowForm} onChangeVisibility={handleChangeForVisibility} hideLabel={t('predictForm')}>
        <PredictForm onPredictResponse={onPredictResponse} />
      </FormSection>

      <SortField onSortChange={handleChangeSort} sort={sort} disabled={isPredicting || isGeneratingAlternate} />

      <MessagesList
        content={sortedMessages}
        className={scss.listWrapper}
        renderMessage={(message) => <PredictedMessage key={`${message.message}-${message.count}`} message={message} />}
        isLoading={isPredicting || isGeneratingAlternate}
      />
    </div>
  );
}

export default PredictResponse;
